import * as React from 'react'

import Slider from 'rc-slider'
import {
  HandlerStyles,
  RailStyles,
  SliderContainer,
  TrackStyles,
  Value,
  ValueContainer,
} from './Slider.styles'

interface IProps {
  maxValue: number
  value: number
  minValue?: number
  onChange?: (value: number) => void
  onAfterChange?: (value: number | number[]) => void
  withoutLabel?: boolean
  step?: number
}

export default function RangeSlider(props: IProps) {
  const { maxValue, minValue, value, onChange, onAfterChange, withoutLabel, step } = props
  const hasLabel = !withoutLabel

  return (
    <>
      <SliderContainer isCentered={hasLabel}>
        <Slider
          min={minValue ? minValue : 0}
          max={maxValue}
          value={value}
          onChange={handleChange}
          onAfterChange={onAfterChange}
          handleStyle={HandlerStyles}
          trackStyle={TrackStyles}
          railStyle={RailStyles}
          step={step}
        />
      </SliderContainer>
      {hasLabel && (
        <ValueContainer>
          <Value>{value}</Value>
        </ValueContainer>
      )}
    </>
  )

  function handleChange(change: number | number[]) {
    if (!onChange) {
      return
    }

    if (typeof change !== 'number') {
      throw new Error('value must be number')
    }

    onChange(change)
  }
}
